module.exports = __webpack_public_path__ + "static/media/timelapse_3.fd3d57bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_3.jpg
// module id = 963
// module chunks = 0